///<reference path="../../employee/sections/employee.bookingRestrictions.section.ts"/>
module Meevo.Plugins.Student {
    "use strict";

    /**
    * Services Booking Restrictions of Employee 
    */
    export class BookingRestrictionsSection extends Meevo.Plugins.Employee.BookingRestrictionsSection {
        public get auditNounForSave() {
            return Model.NounEnum.StudentBookingRestriction;
        }
    }
}